export const MAPPING = {
  SUBJECT: "subjectsV2",
  CLASSROOMS: "classroomsV2",
  STUDENTS: "classroomsV2/students",
  SEMESTERS: "semesters",
  DATA: "data",
  AUTH_TEACHERS: "authorized_teachers",
};
//subjectsV2
